// deps
import { Select } from "@chakra-ui/react";

// hooks
import useLocale from "../../hooks/useLocale";

// constants
import { LOCALES_LANG_NAMES } from "../../constants/locales";

/**
 * @param {import("@chakra-ui/react").SelectProps} props
 */
export default function LocaleSelect(props) {
  const { ...otherProps } = props;

  const { locales } = useLocale();

  return (
    <Select {...otherProps}>
      {locales.map(function (locale) {
        if (locale === "default") {
          return;
        }
        return (
          <option key={locale} value={locale}>
            {LOCALES_LANG_NAMES[locale].name}
          </option>
        );
      })}
    </Select>
  );
}
